import React from 'react';
import './Cementerio.css';

interface ExColaborador {
  nombre: string;
  cargo: string;
  epitafio: string;
  foto: string;
}

const EX_COLABORADORES: ExColaborador[] = [
  {
    nombre: 'Cristián',
    cargo: 'Gerente de Finanzas',
    epitafio: 'Nunca propuso un Excel en su vida. QEPD.',
    foto: '/assets/img/cementerio/gerente_cristian.webp',
  },
  {
    nombre: 'Marilín',
    cargo: 'Terapeuta',
    epitafio: 'Duró menos que un candy. Cero pacientes atendidos.',
    foto: '/assets/img/cementerio/terapista_marilin.webp',
  },
];

const Cementerio: React.FC = () => {
  return (
    <div className="cementerio-view">
      <div className="cementerio-header">
        <h1><i className="fas fa-cross" /> Cementerio</h1>
        <p>Ex colaboradores que ya no oficiaban con nosotros.</p>
      </div>

      <div className="cementerio-grid">
        {EX_COLABORADORES.map((persona) => (
          <div className="cementerio-card" key={persona.nombre}>
            <div className="cementerio-card-photo">
              <img src={persona.foto} alt={persona.nombre} loading="lazy" />
            </div>
            <div className="cementerio-card-body">
              <h3>{persona.nombre}</h3>
              <span className="cementerio-card-cargo">{persona.cargo}</span>
              <p className="cementerio-card-epitafio">"{persona.epitafio}"</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cementerio;
